export const modelQueryKeys = {
  id: 'id',
  name: 'name',
  sort: 'sort',
  createdAt: 'created_at',
  description: 'descr',
};
